import { select, Store } from '@ngrx/store';
import { combineLatest, map, Observable, skipUntil } from 'rxjs';
import {
    DeviceManagementConfigurationPolicy,
    DeviceManagementConfigurationSetting,
} from '@microsoft/microsoft-graph-types-beta';
import { DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/configuration-policy/windows-edge-block-password-saving/model';
import { client } from 'projects/angular-clarity/src/app/stores/client';
import { selectSwaySpecStatus } from 'projects/angular-clarity/src/app/stores/root.store';
import { DeviceConfigurationWindowsSettingSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/configuration-policy/helper';

export function getConfigurationPolicySettingsFromSchema(
    settingsSchema: DeviceConfigurationWindowsSettingSchema,
): DeviceManagementConfigurationSetting[] {
    const items = settingsSchema?.items?.properties?.settingInstance?.oneOf;

    const result = items?.map((schemaItem) => {
        return {
            settingInstance: {
                '@odata.type': '#microsoft.graph.deviceManagementConfigurationChoiceSettingInstance',
                settingDefinitionId: schemaItem?.properties?.settingDefinitionId?.const,
                choiceSettingValue: {
                    value: schemaItem?.properties?.choiceSettingValue?.properties?.value?.const,
                },
            },
        };
    });

    return result || [];
}

// -- might need it in the future
// export function getConfigurationPolicySettingsFromSchemaWithIds(
//     settingsSchema: DeviceConfigurationWindowsEdgeBlockPasswordSavingSettingSchema,
//     settingsInPolicy: DeviceManagementConfigurationSetting[] = [],
// ): DeviceManagementConfigurationSetting[] {
//     const settings = getConfigurationPolicySettingsFromSchema(settingsSchema);
//     return settings.map((setting, index) => {
//         const id = settingsInPolicy.find(
//             (s) => s.settingInstance.settingDefinitionId === setting.settingInstance.settingDefinitionId,
//         )?.id;

//         return {
//             ...setting,
//             id,
//             settingInstance: {
//                 ...setting.settingInstance,
//             },
//         };
//     });
// }

export function getDeviceConfigurationPolicyAssignmentsFromSchema(
    schema: DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema,
) {
    const items = schema.contains.properties?.assignments?.items?.properties?.target?.oneOf;

    //  filter(res => res?.properties?.['@odata.type']?.const === targetType);

    const result = items?.map((schemaItem) => {
        const dataType = schemaItem.properties?.['@odata.type'].const;
        const groupId = schemaItem?.properties?.groupId?.const;

        return {
            '@odata.type': '#microsoft.graph.deviceCompliancePolicyAssignment',
            // id will be set in the effect
            target: {
                '@odata.type': dataType,
                groupId,
            },
        };
    });

    return result || [];
}

export function getDeviceConfigurationPolicySettingsFromSchmea(
    schema: DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema,
) {
    const items = schema.contains.properties?.assignments?.items?.properties?.target?.oneOf;

    //  filter(res => res?.properties?.['@odata.type']?.const === targetType);

    const result = items?.map((schemaItem) => {
        const dataType = schemaItem.properties?.['@odata.type'].const;
        const groupId = schemaItem?.properties?.groupId?.const;

        return {
            '@odata.type': '#microsoft.graph.deviceCompliancePolicyAssignment',
            // id will be set in the effect
            target: {
                '@odata.type': dataType,
                groupId,
            },
        };
    });

    return result || [];
}

export function getTargetGroupsIds(schema: any, type): string[] {
    const items =
        schema?.contains?.properties?.assignments?.items?.properties?.target?.oneOf?.filter(
            (res) => res?.properties?.['@odata.type']?.const === type,
        ) || [];
    const result = items?.map((res) => res.properties.groupId.const);

    return result;
}

export function selectDeviceConfigurationPolicy(
    store: Store,
    tenant: string,
    tag: string,
): Observable<DeviceManagementConfigurationPolicy[]> {
    const baseline$ = store.pipe(select(client(tenant).sway.baselines.bySpecTag(tag)));
    const configurationPolicies$ = store.pipe(select(client(tenant).graph.intune.deviceConfigurationPolicy.all));

    const baselineStatus$ = store.pipe(select(client(tenant).sway.baselines.status));
    const swayStatus$ = store.pipe(select(selectSwaySpecStatus));
    const configurationPoliciesStatus$ = store.pipe(
        select(client(tenant).graph.intune.deviceConfigurationPolicy.status),
    );

    const ready$ = combineLatest([baselineStatus$, swayStatus$, configurationPoliciesStatus$]).pipe(
        map((statuses) => statuses.every((status) => status.loaded)),
    );

    return combineLatest([configurationPolicies$, baseline$]).pipe(
        skipUntil(ready$),
        map(([policies, baseline]) => {
            if (!baseline) return [];
            const schema: DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema = baseline.schema;
            const name = schema?.contains?.properties?.name.const;
            const policy = policies.find((res) => res?.name === name);

            return policy ? [policy] : [];
        }),
    );
}
